<template>
  <div class="ftLegacyIframeContainer">
    <v-progress-linear
      style="margin: 0"
      :height="4"
      :active="iframeLoading"
      :indeterminate="true"
    />
    <api-errors :errors="errors" />
    <iframe
      v-if="ftLink"
      :key="ftLink"
      name="bot"
      class="ftLegacyIframe"
      :src="ftLink"
      @load="iframeLoaded"
    />
  </div>
</template>

<script>
import {ftHost} from '../util/helpers'
import ErrorHandler from '../mixins/errorHandler'
import apiHelpers from '../mixins/itemEditor/mixins/apiHelpers.js'

const ftSessionTimeout = 5 // minutes

export default {
  name: 'LegacyIframe',
  mixins: [ErrorHandler, apiHelpers],
  props: {
    servlet: String,
    parms: Array
  },
  data: function () {
    return {
      ftLink: null,
      iframeLoading: true,
      lastServletParmsHashLookup: {}, // TODO:  We'll need to add garbage collection to clean out old values
      ftLinks: {} // TODO:  We'll need to add garbage collection to clean out old values
    }
  },
  watch: {
    servlet (val) {
      this.generateFtLink()
    },
    parms: {
      handler: function () {
        this.generateFtLink()
      },
      deep: true
    }
  },
  beforeMount () {
    this.generateFtLink()
  },
  methods: {
    iframeLoaded () {
      console.log('Iframe loaded')
      this.iframeLoading = false
    },
    generateServletParmsHash () {
      return this.servlet + ':' + JSON.stringify(this.parms)
    },
    checkLastHashUse () {
      const hash = this.generateServletParmsHash()
      const currentTime = Date.now()
      const lastAccess = this.lastServletParmsHashLookup[hash] || 0
      const diff = currentTime - lastAccess
      return diff > ftSessionTimeout * 60000
    },
    foreTeesLinkBuilder (parms) {
      let q = this.servlet.indexOf('||') !== -1 ? '&' : '?'
      return ftHost() + '/v5/servlet/' + this.servlet.replace('||', '?') + parms.reduce((acc, o) => {
        acc += (acc ? '&' : q) + encodeURIComponent(o.parm) + (o.value === null || o.value === undefined ? '' : '=' + encodeURIComponent(o.value))
        return acc
      }, '')
    },
    singleUseAccessKeyCommand (onLoad) {
      return {
        command: 'singleUseKeyIfNeeded',
        params: {
          user_token: this.$ftUser.userToken
        },
        load: onLoad,
        loading: this.setIsLoading
      }
    },
    generateFtLink () {
      const parms = this.parms || []
      this.iframeLoading = true
      if (this.checkLastHashUse()) {
        console.log('Loading iframe url')
        this.$ftAPI().get(this.addResourceErrorHandler([this.singleUseAccessKeyCommand((suak) => {
          // Success
          console.log('Got SUAK:', suak)
          parms.push({parm: 'sK', value: suak})
          parms.push({parm: 'uT', value: this.$ftUser.userToken})
          const hash = this.generateServletParmsHash()
          const url = this.foreTeesLinkBuilder(parms)
          this.lastServletParmsHashLookup[hash] = Date.now()
          this.ftLinks[hash] = url
          console.log('Opening legacy fortees iframe: ', url)
          if (this.ftLink !== url) this.ftLink = url
        })], (response) => {
          // Error
          console.log('Error from SUAK', response)
          this.iframeLoading = false
          // Todo: display error
        }))
      } else {
        console.log('Using existing iframe url')
        const hash = this.generateServletParmsHash()
        const url = this.ftLinks[hash]
        if (this.ftLink !== url) this.ftLink = url
      }
    }
  }
}
</script>
<style>
  .content--wrap {
    position: relative;
  }
  .ftLegacyIframeContainer {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: none;
  }
  .ftLegacyIframe {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: none;
  }
</style>
